import mensajeError from "../mensajes/MensajeError";

/**
 * Obtiene lsta de ingresos mensuales
 * @param {Number} primavera 
 * @param {Number} idestatus 
 * @param {Number} idConceptoPago 
 * @param {Number} idUsuario 
 * @param {Function} setPrimaveraValues 
 */
export default function reporteGeneral(primavera1, primavera2, dia1, dia2, mes1, mes2, idConceptoPago, listaEstatus, listaUsuarios, setValores) {
    let listaFinalEstatus = [];
    let listaUsuariosFinal = [];
    for (let i = 0; i < listaUsuarios.length; i++) {
        listaUsuariosFinal.push(listaUsuarios[i].id)
    }

    for (let i = 0; i < listaEstatus.length; i++) {
        listaFinalEstatus.push(listaEstatus[i].id)
    }

    let listaEstatusString = listaFinalEstatus.toString();
    let listaUsariosString = listaUsuariosFinal.toString();
    idConceptoPago = 0;
    const endpoint = `/api/reporteGeneral/Obtener?primavera1=${primavera1}&primavera2=${primavera2}&dia1=${dia1}&dia2=${dia2}
    &mes1=${mes1}&mes2=${mes2}&idConceptoPago=${idConceptoPago}&idUsuarioElabora=${listaUsariosString ?? ""}&idEstatus=${listaEstatusString ?? ""}`;
    fetch(endpoint)
        .then(response => response.json())
        .then(data => {
            setValores([...data.data]);
        })
        .catch(error => {
            mensajeError(error.message);
        });
}